import { QueryClient, type QueryClientConfig } from '@tanstack/react-query'

/**
 * The app-wide query defaults. Exported on their own so a test can build a
 * client with the same behaviour without importing this package's QueryClient
 * class, which the monorepo currently resolves to a second copy of
 * @tanstack/query-core.
 *
 * `refetchOnMount: false` with a non-zero `staleTime` means a query given
 * `initialData` never runs its queryFn. Use `placeholderData` for a
 * provisional value.
 */
export function queryDefaults(
	overrides?: QueryClientConfig,
): QueryClientConfig {
	return {
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				refetchOnReconnect: false,
				refetchOnMount: false,
				staleTime: 1000 * 30,
				gcTime: 1000 * 60 * 5,
				retry: 1,
				...overrides?.defaultOptions?.queries,
			},
		},
	}
}

export function createQueryClient(overrides?: QueryClientConfig) {
	return new QueryClient(queryDefaults(overrides))
}
